import { IsiEvents } from "../Events/IsiEvents";
import { IsiDtoComponentClientState, IIsiDtoComponentClientState } from "../../../../Dtos/Isilog.IsiFramework.IsiDataTransferObject";

/**
 * Représente l'état d'un composant coté client
 **/
export class IsiComponentClientState<TDatas extends IIsiDtoComponentClientState> {

    private _events: IsiEvents;
    private _isLoaded: boolean
    private _datas: TDatas;
    private readonly _initDtoFn: (data: TDatas) => TDatas;

    constructor(initDtoFn: (data: TDatas) => TDatas) {
        this._events = new IsiEvents();
        this._initDtoFn = initDtoFn;
    }

    get events() {
        return this._events;
    }

    get isLoaded() {
        return this._isLoaded;
    }

    get datas() {
        return this._datas;
    }

    loadObject(datas: TDatas) {
        this._datas = datas;
        this._loadOverridable();
        this._isLoaded = true;
    }

    loadSerialized(datas: string) {
        var serializedDatas = JSON.parse(datas);
        if (serializedDatas) {
            this._datas = this._initDtoFn(serializedDatas);
            this._loadOverridable();
            this._isLoaded = true;
        }
    }
    initEmptyState(data: TDatas) {
        this._datas = data;
    }
    _loadOverridable() {

    }
}
